// Bantuan (the profile menu, and the guest bar): what the two kinds of answer are, that every answer is a
// recommendation for the officer to check, never a decision, and (for roles
// that can generate) that the assistant can draft a document proposal.
import { Dialog } from "../ui/components";
import { Glyph, type GlyphName } from "../ui/icons";
import { draftExampleFor } from "./support";

interface Point {
  icon: GlyphName;
  title: string;
  /** The text for a Penyedia (true) or anyone else (false). */
  body: (penyedia: boolean) => string;
  /** Shown only to roles that can generate documents. */
  drafting?: boolean;
  /** Shown only to a signed-in user (true) or only to a guest (false). */
  member?: boolean;
}

const POINTS: Point[] = [
  {
    icon: "bookOpen",
    title: "Jawaban tersimpan",
    body: () => "Pertanyaan umum dijawab langsung dari jawaban yang sudah disusun dan diperiksa. Tidak mengurangi kuota pesan Anda.",
  },
  {
    icon: "magicStar",
    title: "Dijawab Pluto",
    body: () => "Pertanyaan yang Anda ketik dijawab Pluto dari basis pengetahuan (Library), dan sumber yang dipakai ditampilkan di bawah jawaban.",
  },
  {
    icon: "shieldTick",
    title: "Rekomendasi, bukan keputusan",
    body: (penyedia) =>
      penyedia
        ? "Periksa kembali setiap jawaban sebelum dipakai dan sesuaikan dengan dokumen pemilihan paket. Keputusan ikut serta, harga, dan isi penawaran tetap pada Anda."
        : "Periksa kembali setiap jawaban sebelum dipakai. Keputusan tetap pada pejabat berwenang, dan asisten tidak pernah membuat dokumen tanpa konfirmasi Anda.",
  },
  {
    icon: "docAdd",
    title: "Menyusun dokumen",
    body: (penyedia) =>
      penyedia
        ? `Minta Pluto menyusun dokumen penawaran Anda, contoh: "${draftExampleFor("penyedia")}". Di project paket, Pluto memakai data paketnya. Periksa isinya, lalu unduh DOCX atau buat dokumennya.`
        : `Minta asisten menyusun usulan dokumen, contoh: "${draftExampleFor(null)}". Periksa dan lengkapi usulannya, lalu tekan Buat dokumen. Dokumen yang dibuat terbuka dari tautan di percakapan.`,
    drafting: true,
  },
  {
    icon: "lock",
    title: "Percakapan pribadi",
    body: () => "Riwayat percakapan hanya dapat dilihat oleh Anda, dan dapat Anda ganti nama atau hapus kapan saja.",
    member: true,
  },
  {
    icon: "lock",
    title: "Mode tamu",
    body: () => "Tanpa masuk, Anda dapat mengirim 5 pesan, lalu jeda 30 menit sebelum dapat mengirim lagi, dan percakapan tidak disimpan. Masuk dengan Google untuk menyimpan riwayat dan membuat project.",
    member: false,
  },
];

export function HelpDialog({
  open,
  canDraft = false,
  guest = false,
  penyedia = false,
  onClose,
}: {
  open: boolean;
  canDraft?: boolean;
  guest?: boolean;
  /** A Penyedia reads supplier wording (no "pejabat berwenang", no government KAK example). */
  penyedia?: boolean;
  onClose: () => void;
}) {
  const points = POINTS.filter((p) => (canDraft || !p.drafting) && (p.member === undefined || p.member === !guest));
  return (
    <Dialog
      open={open}
      title="Bantuan Chat"
      description="Cara Pluto menjawab pertanyaan Anda."
      onClose={onClose}
      footer={
        <button type="button" className="btn btn-primary" onClick={onClose}>
          Mengerti
        </button>
      }
    >
      <ul className="help-list">
        {points.map((p) => (
          <li key={p.title} className="help-item">
            <span className="help-icon">
              <Glyph name={p.icon} />
            </span>
            <span className="help-text">
              <span className="help-title">{p.title}</span>
              <span className="help-body">{p.body(penyedia)}</span>
            </span>
          </li>
        ))}
      </ul>
    </Dialog>
  );
}
